import { Injectable } from '@angular/core';
import { StarbaseDataService } from 'starbase-launcher';
import { LUSource } from '../models/luSource';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class SourceService extends StarbaseDataService<LUSource> {
  protected _staleDataTimeout = 2000;
  protected _getOneUri = '/api/LU_SourceModels/';
  protected _getAllUri = '/api/LU_SourceModels';
  protected _postUri = '/api/LU_SourceModels';
  protected _putUri = '/api/LU_SourceModels/';
  protected _deleteUri = '/api/LU_SourceModels/';
  protected _broadSearchUri = '/api/LU_SourceModels/GetSourceBroadSearch';

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }
}
